module.exports = __webpack_public_path__ + "img/Mar-Business_1.cf60e8e4.svg";